import { useState,useEffect } from 'react';
import RemittanceView from './RemittanceView';
import {AGENT_LEAD_TYPES} from '../../config/constant'

const RemittanceDetailTabs = (props: any) => {
    const { remittanceDetails,callReloadApi,setCallReloadApi,revenue,remittance_status } = props;
    const [selectedTab, setSelectedTab] = useState<string>("premium");
    // const [callReloadApi , setCallReloadApi] = useState(0);
    const [isPartnerRemittanceExists , setIsPartnerRemittanceExists] = useState(false);
    const [isReferralRemittanceExists , setIsReferralRemittanceExists] = useState(false);
    const [isAgencyRemittanceExists , setIsAgencyRemittanceExists] = useState(false);

    const isLeadFromAgency = AGENT_LEAD_TYPES.includes(revenue?.application_type_id);

    useEffect(() => {
        const container = document.querySelector('.remittance-wrapper');
        if (!container) return;

        const handleScroll = () => {
            const sections = ['premium', 'oto', 'agencyPayout', 'insurerPartner', 'dealer', 'agencyRemit'];

            for (let i = sections.length - 1; i >= 0; i--) {
            const el = document.getElementById(sections[i]);
            if (el) {
                const top = el.getBoundingClientRect().top - container.getBoundingClientRect().top;
                if (top <= 150) {
                setSelectedTab(sections[i]);
                break;
                }
            }
            }
        };

        container.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => container.removeEventListener('scroll', handleScroll);
    }, []);


    useEffect(() => {
  const container = document.querySelector('.route-files');
  if (!container) return;

  const handleScroll = () => {
    console.log("scroll happened!");
    // your scroll logic
  };

  container.addEventListener('scroll', handleScroll);

  return () => container.removeEventListener('scroll', handleScroll);
}, []);


    return (
        <div className="lead-detail-tabs">
        <div className="detail-form-sec">
            <div className="menu-tab-left-panel remitttance-side-bar">
                <div className="dealer-tab-left-panel nav">
                <ul>
                    <li >
                        <a href=":" className={selectedTab === 'premium' ? 'active' : ''} onClick={(e) => { e.preventDefault(); document.getElementById('premium')?.scrollIntoView({ behavior: 'smooth' });}}>Premium Remittance</a>
                    </li>
                    <li >
                        <a href=":" className={selectedTab === 'oto' ? 'active' : ''} onClick={(e) => { e.preventDefault(); document.getElementById('oto')?.scrollIntoView({ behavior: 'smooth' });}}>OTO's Revenue</a>
                    </li>
                    {
                        isLeadFromAgency &&
                        <li >
                            <a href=":" className={selectedTab === 'agencyPayout' ? 'active' : ''} onClick={(e) => { e.preventDefault(); document.getElementById('agencyPayout')?.scrollIntoView({ behavior: 'smooth' });}}>Agency Payout</a>
                        </li>
                    }
                    {
                        isPartnerRemittanceExists && 
                        <li >
                            <a href=":"  className={selectedTab === 'insurerPartner' ? 'active' : ''} onClick={(e) => { e.preventDefault(); document.getElementById('insurerPartner')?.scrollIntoView({ behavior: 'smooth' });}}>Insurer Partner Remittance</a>
                        </li>
                    }
                    {
                        isReferralRemittanceExists &&
                        <li >
                            <a href=":" className={selectedTab === 'dealer' ? 'active' : ''} onClick={(e) => { e.preventDefault(); document.getElementById('dealer')?.scrollIntoView({ behavior: 'smooth' });}}>Referral Fee Remmittance</a>
                        </li>
                    }
                    {
                        isLeadFromAgency && isAgencyRemittanceExists &&
                        <li >
                            <a href=":" className={selectedTab === 'agencyRemit' ? 'active' : ''}  onClick={(e) => { e.preventDefault(); document.getElementById('agencyRemit')?.scrollIntoView({ behavior: 'smooth' });}}>Agency Remittance</a>
                        </li>
                    }
                </ul>
                </div>
            </div>
            <div className="route-files">
                <RemittanceView isLeadFromAgency={isLeadFromAgency} remittanceDetails={remittanceDetails} revenue={revenue} callReloadApi={callReloadApi} setCallReloadApi={setCallReloadApi} remittance_status={remittance_status}
                setIsPartnerRemittanceExists={setIsPartnerRemittanceExists} setIsReferralRemittanceExists={setIsReferralRemittanceExists} setIsAgencyRemittanceExists={setIsAgencyRemittanceExists}></RemittanceView>
            </div>
        </div>
        </div>
    );
}

export default RemittanceDetailTabs;